import * as React from 'react';
import clsx from 'clsx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import arrowLeft from '@/assets/images/svg/left_arrow.svg'; // Reuse existing asset

export const InfoSidebar: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'terms';

  const handleTabChange = (tab: string) => {
    navigate(`/info?tab=${tab}`);
  };

  const tabs = [
    { id: 'terms', label: 'Terms & Conditions' },
    { id: 'privacy', label: 'Privacy Policy' },
    { id: 'cookie', label: 'Cookie Policy' },
    { id: 'creator', label: 'Creator Agreements' },
  ];

  return (
    <aside className='hidden w-[300px] flex-col border-r border-gray-200 bg-white p-6 md:flex'>
      <button
        onClick={() => navigate('/home')}
        className='mb-8 flex items-center gap-2 text-gray-600 hover:text-brand-800'
      >
        <img src={arrowLeft} alt='Back' className='size-4 rotate-0' />
        <span className='font-sans text-14 font-medium'>Back to Explore</span>
      </button>

      <div className='flex flex-col gap-2'>
        <h2 className='mb-4 font-sans text-12 font-bold uppercase tracking-wider text-gray-500'>
          Legal Information
        </h2>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={clsx(
              'rounded-lg px-4 py-3 text-left font-sans text-14 font-medium transition-colors',
              activeTab === tab.id
                ? 'bg-brand-50 text-brand-800'
                : 'text-gray-600 hover:bg-gray-50 hover:text-brand-800'
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </aside>
  );
};
